import { format } from 'date-fns';

export const numMonths = [...Array(12)].map((_, i) => 1 + i);
export const monthNames = numMonths.reduce((acc: Record<number, string>, n) => {
  acc[n] = format(new Date(2000, n - 1, 1), 'MMMM');
  return acc;
}, {});
